import { render, staticRenderFns } from "./GRCRequirementsList.vue?vue&type=template&id=d4c80fec&scoped=true&"
import script from "./GRCRequirementsList.vue?vue&type=script&lang=js&"
export * from "./GRCRequirementsList.vue?vue&type=script&lang=js&"
import style0 from "./GRCRequirementsList.vue?vue&type=style&index=0&id=d4c80fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c80fec",
  null
  
)

export default component.exports